import React, { useState } from "react";
import { buildCsv, downloadFile } from "../../utils/csvExport";

// Standard download icon: arrow down to horizontal bar (matches reference design)
function DownloadIcon({ className = "" }) {
    return (
        <svg className={className} width="16" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M0 17.5H14V15.5H0V17.5ZM14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5Z" fill="currentColor" />
        </svg>
    );
}

function DownloadDropdown({
    allLabel = "All sites",
    tableLabel = "Table sites",
    tableData = [],
    columns = [],
    onDownloadAll,
    filenameBase = "sites",
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [downloading, setDownloading] = useState(false);

    const toggleDropdown = () => {
        if (!downloading) setIsOpen(!isOpen);
    };

    const handleDownloadTable = () => {
        setIsOpen(false);
        if (!tableData.length) {
            alert("No data to download.");
            return;
        }
        const csv = buildCsv(tableData, columns);
        const filename = `${filenameBase}-table-${formatDate()}.csv`;
        downloadFile(csv, filename);
    };

    const handleDownloadAll = async () => {
        setIsOpen(false);
        setDownloading(true);
        try {
            const data = await onDownloadAll();
            if (!data || !data.length) {
                alert("No data to download.");
                return;
            }
            const csv = buildCsv(data, columns);
            const filename = `${filenameBase}-all-${formatDate()}.csv`;
            downloadFile(csv, filename);
        } catch (err) {
            console.error("Download failed:", err);
            alert("Failed to download. Please try again.");
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="telemetry-select-dd no-seprator telemetry-change-length telemetry-download-dd">
            <span
                className={downloading ? "telemetry-download-trigger is-loading" : "telemetry-download-trigger"}
                onClick={toggleDropdown}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggleDropdown(); } }}
            >
                <DownloadIcon className="telemetry-download-trigger-icon" />
                Download
            </span>
            {isOpen && (
                <>
                    <div className="telemetry-dd-backdrop" onClick={() => setIsOpen(false)} aria-hidden="true" />
                    <ul className="telemetry-dd">
                        <li onClick={handleDownloadAll}>
                            <DownloadIcon className="telemetry-dd-item-icon" />
                            {allLabel}
                        </li>
                        <li onClick={handleDownloadTable}>
                            <span className="telemetry-dd-icon-table" aria-hidden="true" />
                            {tableLabel}
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}

function formatDate() {
    const d = new Date();
    return d.toISOString().slice(0, 10);
}

export default DownloadDropdown;
